<template>
  <div>
    <!---DIALOG EXTRATO-->
    <v-dialog v-model="dialogExtrato" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="secondary">
          <v-btn icon dark @click.native="dialogExtrato = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Extrato Cartão Nº {{selCartao}} - Cliente : {{selCliente}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="dialogExtrato = false">Fechar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <Extrato :cartao="selCartao"></Extrato>
      </v-card>
    </v-dialog>

    <!--*********************-->
    <v-container grid-list-md fluid fill-height>
      <v-layout row wrap>
        <v-flex xs12>
          <v-progress-linear color="carregando" v-show="loading" :indeterminate="true"></v-progress-linear>
          <v-card v-show="mostraCartoes" light class="Black--text" color="card">
            <v-card-title primary-title>
              <div class=".pa-1 text-md-left headline">Movimentação Cartões</div>
            </v-card-title>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
              <v-spacer></v-spacer>
            </v-card-title>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="cartoes"
                :loading="false"
                :search="search"
                rows-per-page-text="registros por página"
                no-data-text="Nenhum resultado encontrado!"
                no-results-text="Nenhum resultado encontrado!"
                class="elevation-1"
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <span slot="activator">{{ props.header.text }}</span>
                    <span>{{ props.header.text }}</span>
                  </v-tooltip>
                </template>
                <template slot="items" slot-scope="props">
                  <td class="text-xs-left">{{ props.item.num_cartao }}</td>
                  <td class="text-xs-left">{{ props.item.cliente }}</td>
                  <td class="text-xs-rigth">{{ formata_moeda(props.item.saldo) }}</td>
                  <td class="text-xs-left">
                    <v-switch
                      color="red"
                      :label="`${checkStatus(props.item.bloqueio)}`"
                      @change="mudarStatus(props.item.num_cartao,props.item.bloqueio)"
                      v-model="props.item.bloqueio"
                      value
                    ></v-switch>
                  </td>
                  <td class="justify-center layout px-0">
                    <v-btn
                      small
                      color="secondary"
                      class="mx-0 white--text"
                      @click.native="verExtrato();dialogExtrato = true;selCartao= props.item.num_cartao;selCliente=props.item.cliente  "
                    >
                      <v-icon color="white darken-2">receipt</v-icon>Extrato
                    </v-btn>
                  </td>
                </template>
                <template
                  slot="pageText"
                  slot-scope="props"
                >de{{ props.pageStart }} até {{ props.pageStop }} de {{ props.itemsLength }}</template>
              </v-data-table>
            </v-flex>
          </v-card>
          <a href="#" target="_blank" id="linkDownload" download></a>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      :timeout="5000"
      :color="sucesso"
      :top="true"
      :multi-line="'multi-line'"
      :vertical="'vertical'"
      v-model="snackbarSuccess"
    >
      Status alterado com sucesso.
      <v-btn dark flat @click.native="snackbarSuccess = false">Fechar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
import EventBus from "../services/EventBus";

const Extrato = () => import("@/components/Extrato");

export default {
  name: "Movimentacao",
  mixins: [formata],
  components: {
    Extrato
  },
  data: () => ({
    snackbarSuccess: false,
    drawer: null,
    sucesso: "sucesso",
    mostraCartoes: false,
    loading: false,
    dialogExtrato: false,
    selCartao: "",
    selCliente: "",
    valor: "",
    nome: "",
    search: "",
    cartoes: [
      {
        num_cartao: "",
        validade: "",
        saldo: "",
        bloqueio: "",
        cliente: ""
      }
    ],
    headers: [
      {
        text: "Nº Cartão",
        sortable: true,
        align: "left",
        value: "num_cartao"
      },
      {
        text: "Cliente",
        align: "left",
        value: "cliente"
      },
      {
        text: "Saldo",
        align: "center",
        value: "saldo"
      },
      {
        text: "Status",
        width: "250",
        value: "status",
        sortable: false
      },
      {
        text: "Ações",
        value: "operacao",
        sortable: false
      }
    ]
  }),
  computed: {
    getNome() {
      return window.sessionStorage.getItem("nome");
    }
  },
  methods: {
    pdf() {
      alert("pdf");
      HTTP.get(`/pdf`).then(response => {
        setTimeout(() => {
          document.getElementById("linkDownload").href = response.data.url;
          //document.getElementById("linkDownload").download =
          // '"http://192.168.1.135:75/GKFq70ibiI38urfHml.pdf"';
          document.getElementById("linkDownload").click();
        }, 600);
      });
    },
    checkStatus(valor) {
      if (valor) {
        return "Bloqueado";
      } else {
        return "Desbloqueado";
      }
    },
    mudarStatus(id, status) {
      if (status) {
        return false;
      } else {
        HTTP.patch(`cartao/` + id, {
          cod_bloqueio: "0"
        }).then(response => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbarSuccess = true;
          } else {
            this.snackbarSuccess = true;
          }
          this.loading = false;
        });
      }
    },
    verExtrato(cartao) {
      //window.sessionStorage.setItem("cartao", cartao);
      setTimeout(() => {
        EventBus.$emit("buscaExtratoCartao");
      }, 500);
    },

    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaSaldoCartoes() {
      this.loading = true;
      HTTP.get(`grupo/lista/cartao`).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          this.cartoes = response.data;
          this.mostraCartoes = true;
        }
        this.loading = false;
      });
    }
  },
  mounted() {
    this.buscaSaldoCartoes();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Movimentacao.vue